import { useServicesContext } from "@modules/core/services/services.context"
import { DEFAULT_UNIT, type HUUnit } from "@modules/utils/unitType"
import { useObservable } from "micro-observables"

export const useUnit = (): HUUnit => {
  const { browserProfileService } = useServicesContext()
  return useObservable(browserProfileService.profileUnit.select((profileUnit) => profileUnit.unit)) ?? DEFAULT_UNIT
}
